import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export type ContentContextType = 'game' | 'section' | 'sections';

export interface ContentItem {
  id: string;
  name: string;
}

export interface ContentContext {
  type: ContentContextType;
  items: ContentItem[];
}

@Injectable({providedIn: 'root'})
export class ContentContextService {
  private subject = new BehaviorSubject<ContentContext | null>(null);
  readonly context$ = this.subject.asObservable();

  set(ctx: ContentContext): void { this.subject.next(ctx); }
  clear(): void { this.subject.next(null); }
}
